import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import DataTableAnafLog from "@/components/DataTableAnafLog.vue";
import DialogLoader from "@/components/DialogLoader.vue";
import { onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";
import dayjs from "dayjs";

type tInvoice = {
  PartitionKey: string;
  RowKey: string;
  name: string;
  invoiceID: string;
  issueDateF: string;
  TimestampF: string;
  anafErr: string;
  anafState: string;
  anafIncarcare: string;
  anafDescarcare: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TableInvoicesPending',
  setup(__props) {

const invoices = ref<tInvoice[]>([]);
const invoice = ref<tInvoice>();
let chosenFiles = [] as File[];
const uploadState = ref({ progress: 0, fileName: "" });
const showProgress = ref(false);
const showAnafLog = ref(false);
const showLoader = ref(false);

onMounted(() => {
  getInvoices();
});

store.watch(
  (state) => state.invoicesUploaded,
  (uploaded) => {
    if (uploaded) {
      getInvoices();
      store.commit("setInvoicessUploaded", false);
    }
  }
);
function getInvoices() {
  showLoader.value = true;
  axios
    .get("api/v1/invoicespending")
    .then((response) => {
      response.data.forEach(
        (invoice: {
          Timestamp: string;
          TimestampF: string;
          issueDate: string;
          issueDateF: string;
        }) => {
          invoice.TimestampF = dayjs(invoice.Timestamp).format(
            "DD/MM/YYYY HH:mm"
          );
          invoice.issueDateF = dayjs(invoice.issueDate).format("DD/MM/YYYY");
        }
      );
      invoices.value = response.data;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

function downloadInvoice(invoice: { RowKey: string; name: string }) {
  axios
    .get(`api/v1/invoicepending/${invoice.RowKey}`, {
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoice.name}`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

const uploadSelectFilesInput = () => {
  const input = document.createElement("input");
  input.type = "file";
  input.multiple = true;
  input.addEventListener("change", (e: Event) => {
    chosenFiles = Array.from((e.target as HTMLInputElement)?.files as FileList);
    filesUpload();
  });
  input.click();
};

function filesUpload() {
  const requests = chosenFiles.reduce((promiseChain, item) => {
    return promiseChain.then(
      () =>
        new Promise((resolve) => {
          showProgress.value = true;
          uploadState.value.fileName = item.name;
          axios
            .post(`/api/v1/invoicepending`, item, {
              headers: {
                "Content-Type": item.type,
                "Content-Disposition": `attachment; filename="${encodeURIComponent(
                  item.name
                )}"`,
              },
              onUploadProgress: function (progressEvent) {
                uploadState.value.progress = Math.round(
                  (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
              },
            })
            .then(() => {
              // this.uploadStep++;
              getInvoices();
              showProgress.value = false;
              uploadState.value = { progress: 0, fileName: "" };
              resolve();
            })
            .catch((err) => {
              showProgress.value = false;
              uploadState.value = { progress: 0, fileName: "" };
              if (err.code === "ERR_NETWORK") {
                store.commit("setToast", {
                  sev: "error",
                  sum: "Network error",
                  det: "File too large or network error",
                });
                return;
              }
              store.dispatch("catchErr", err);
            });
        })
    );
  }, Promise.resolve());
  requests.then(() => {
    store.commit("setToast", {
      sev: "success",
      sum: "Upload done",
      det: "All files succesfully uploaded",
    });
    // this.chosenFiles = [];
    // this.uploadLoader = false;
    // this.loadFiles();
  });
}

function processAllInvoices() {
  showLoader.value = true;
  axios
    .get("api/v1/invoicependingprocess")
    .then(() => {
      store.commit("setToast", {
        sev: "success",
        sum: "Invoices processed",
        det: "All invoices processed",
      });
      getInvoices();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      label: "Upload",
      icon: "pi pi-plus",
      class: "p-button-success p-button-rounded mx-3",
      onClick: uploadSelectFilesInput
    }),
    _createVNode(_component_Button, {
      label: "Update all invoices",
      icon: "pi pi-refresh",
      class: "p-button-success p-button-rounded mx-3",
      onClick: processAllInvoices
    }),
    _createVNode(_component_DataTable, {
      value: invoices.value,
      scrollHeight: `${_unref(store).state.win.h - 140}px`,
      style: _normalizeStyle(`height: ${_unref(store).state.win.h - 140}px; width: ${
      _unref(store).state.win.w - 230
    }px`),
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Status",
          style: {"max-width":"40px"}
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.anafErr)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-times",
                  class: "p-button-rounded p-button-danger",
                  style: {"width":"40px","height":"40px"},
                  onClick: ($event: any) => ((showAnafLog.value = true), (invoice.value = slotProps.data))
                }, null, 8, ["onClick"])), [
                  [
                    _directive_tooltip,
                    slotProps.data.anafErr,
                    void 0,
                    { bottom: true }
                  ]
                ])
              : (
            slotProps.data.anafState || slotProps.data.anafIncarcare !== ''
          )
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "pi pi-stopwatch",
                    class: "p-button-rounded p-button-success",
                    style: {"width":"40px","height":"40px"},
                    onClick: ($event: any) => ((showAnafLog.value = true), (invoice.value = slotProps.data))
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      slotProps.data.anafState,
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    icon: "pi pi-info-circle",
                    class: "p-button-rounded p-button-warning",
                    style: {"width":"40px","height":"40px"},
                    onClick: ($event: any) => ((showAnafLog.value = true), (invoice.value = slotProps.data))
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      'Show Anaf communication log',
                      void 0,
                      { bottom: true }
                    ]
                  ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "File",
          style: {"max-width":"80px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              icon: "pi pi-download",
              class: "p-button-rounded p-button-success",
              style: {"width":"40px","height":"40px"},
              onClick: ($event: any) => (downloadInvoice(slotProps.data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "TimestampF",
          header: "Updated",
          sortable: "",
          sortField: "Timestamp",
          style: {"min-width":"160px"}
        }),
        _createVNode(_component_Column, {
          field: "invoiceID",
          header: "Invoice ID",
          sortable: "",
          style: {"min-width":"100px","max-width":"400px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "File name",
          sortable: "",
          style: {"min-width":"100px","max-width":"400px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
        }),
        _createVNode(_component_Column, {
          field: "issueDateF",
          header: "Issued",
          sortable: "",
          sortField: "issueDate",
          style: {"min-width":"140px"}
        })
      ]),
      _: 1
    }, 8, ["value", "scrollHeight", "style"]),
    _createVNode(_component_Dialog, {
      class: "w-30rem",
      visible: showProgress.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showProgress).value = $event)),
      modal: "",
      closable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("b", null, _toDisplayString(uploadState.value.fileName), 1),
        _createVNode(_component_ProgressBar, {
          value: uploadState.value.progress
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: `Invoice Status: ${invoice.value?.name} (${invoice.value?.invoiceID})`,
      class: "w-60vw",
      visible: showAnafLog.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((showAnafLog).value = $event)),
      modal: ""
    }, {
      default: _withCtx(() => [
        (showAnafLog.value)
          ? (_openBlock(), _createBlock(DataTableAnafLog, {
              key: 0,
              invoice: invoice.value,
              onCloseAnafLog: _cache[1] || (_cache[1] = ($event: any) => ((showAnafLog.value = false), getInvoices()))
            }, null, 8, ["invoice"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(DialogLoader, { showLoader: showLoader.value }, null, 8, ["showLoader"])
  ], 64))
}
}

})